import { getEnvVar } from "./env-utils";

export const generateCodeChallenge = async (codeVerifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);

  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const base64Hash = btoa(String.fromCharCode.apply(null, hashArray))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

  return base64Hash;
};

export const redirectToFallback = (reason: string) => {
  const fallbackUrl = getEnvVar("VITE_FALLBACK_URL");
  /*     if (cookies.fallbackurl) {
      console.log("Fallback URL from cookie:", fallbackUrl);
    } else if (fallbackUrl) {
      console.log("Fallback URL from env:", fallbackUrl);
    }  */
  if (fallbackUrl) {
    window.location.href = fallbackUrl;
  }
};
